import { Hero } from '@agria/theme-qab/src/components/Hero';
import { SEO } from '@agria/theme/src/components/Seo';
import { useSiteMetadata } from '@agria/theme/src/hooks/useSiteMetadata';
import React from 'react';

const NotFoundPage = () => (
  <Hero heading="Page not found" trustpilotStars override="default" />
);

export default NotFoundPage;

export const Head = () => {
  const { companyName } = useSiteMetadata();
  return (
    <SEO
      title={`Page not found | ${companyName}`}
      meta={[{ name: 'robots', content: 'noindex, nofollow' }]}
    />
  );
};
